/*
一次充电成功率
 */
import React, { Component } from "react";
import "@/assets/stylus/data_analysis.styl";
import PropTypes from "prop-types";
import "@ant-design/compatible/assets/index.css";
import { Affix, Row, Col } from "antd";
import FormCore from "@/components/display/form/formCore";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import moment from "moment";
// 业务接口
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ChargeSuccessMonth from "./chargeSuccessMonth";
import ChargeSuccessDay from "./chargeSuccessDay";
import ChargeSuccessFirmware from "./chargeSuccessFirmware";
import StopReason from "./stopReason";
import Top10Station from "./top10Station";
import Top100Equipment from "./top100Equipment";
import Top50Chanel from "./top50Chanel";

import {
  getCityList,
  getChargeSuccessRateByMon,
  getChargeSuccessRateByDay,
  getChargeSuccessRateByFirmware,
  getStopReason,
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "./index.styl";

// 国际化切换语言

const SORT_TYPE_OPTIONS = [
  // value替换为对应字段
  { name: "订单总数", value: "0" },
  { name: "成功订单数", value: "1" },
  { name: "失败订单数", value: "2" },
  { name: "成功率", value: "3" },
];

const SORT_ORDER_OPTIONS = [
  { name: "从高到低", value: "-1" },
  { name: "从低到高", value: "1" },
];

@CityDataFilterHoc
@connect((state) => state)
class ChargeSuccess extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargSuccess;

    this.props = props;
    this.state = {
      chooseDate: moment(new Date()).subtract(0, "d"), // 选择的日期
      formConfig: null,
      typeOption: [
        {
          text: "全部",
          value: "",
        },
      ],
      params: {
        time: moment(new Date()).subtract(0, "d"),
        successType: 1,
      },
      timeType: "pickMonth", // 查询form表单 日期表单选择方式  pickMonth：年月选择； pickDate：年月日选择
      monthDataList: [], // 按月呈现数据源
      dailyDataList: [], // 按日呈现数据源
      firmwareDataList: [], // 固件版本数据源
      stopReasonDataList: [], // 停止原因数据源
    };
  }

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });

    this.initSource();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  initFormConfig() {
    this.setState({
      isSearch: 1,
    });

    const option1 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "星充直营",
        value: "2",
      },
      {
        text: "加盟直营",
        value: "3",
      },
      {
        text: "联营",
        value: "1",
      },
      {
        text: "他营",
        value: "0",
      },
      {
        text: "人人电站",
        value: "5",
      },
    ];

    const option2 = [
      {
        text: "全部",
        value: "",
      },
      {
        text: "私桩",
        value: "0",
      },
      {
        text: "非私桩",
        value: "1",
      },
    ];

    const option3 = [
      {
        text: "全部",
        value: "",
      },
    ];

    const formConfig = {
      childItems: [
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder2, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区:",
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              width: "95px",
              options: [
                {
                  text: "全部",
                  value: "",
                },
                {
                  text: "运营",
                  value: "1",
                },
                {
                  text: "运维",
                  value: "0",
                },
              ],
              placeholder: "请选择",
              param: {
                name: "operationProperty",
                type: "string",
              },
              labelName: "运营类型:",
              required: false,
              onChange: (value, form) => {
                form.setFieldsValue({
                  operationProperty: value,
                  operationMode: "",
                });
                console.log(this.state.isSearch);
                const stubType2List = [];
                if (value === "0") {
                  stubType2List.push(...option2);
                } else if (value === "1") {
                  stubType2List.push(...option1);
                } else if (value === "") {
                  stubType2List.push(...option3);
                }
                this.setState(
                  {
                    typeOption: [...stubType2List],
                    isSearch: 1,
                  },
                  () => {
                    this.setState({
                      formConfig: this.initFormConfig(),
                      isSearch: 1,
                    });
                  },
                );
              },
            },
            {
              type: "select",
              width: "95px",
              placeholder: "请选择",
              param: {
                name: "operationMode",
                type: "string",
              },
              labelName: "",
              options: this.state.typeOption,
              required: false,
            },
          ],
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.internationalization.type1, // '交流',
              value: "0",
            },
            {
              text: this.internationalization.type2, // '直流',
              value: "1",
            },
            {
              text: "交直流", // '交直流',
              value: "2",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "type",
            type: "string",
          },
          labelName: this.internationalization.title4, // '设备类型:',
          required: false,
          defaultValue: "",
        },
        {
          type: "select",
          options: [
            {
              text: "充电成功率", // '交流',
              value: "1",
            },
            {
              text: "启动成功率", // '直流',
              value: "0",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "successType",
            type: "string",
          },
          labelName: "类型", // '成功率类型:',
          required: false,
          defaultValue: "1",
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              options: [
                {
                  text: "月",
                  value: "1",
                },
                {
                  text: "日",
                  value: "0",
                },
              ],
              width: "80px",
              // placeholder: ['请选择',],
              param: {
                name: "searchType",
                type: "string",
              },
              onChange: (value, form) => {
                // 日期类型选择后执行，设置日期选择样式
                form.setFieldsValue({
                  searchType: value,
                });
                if (value === "0") {
                  this.setState(
                    {
                      timeType: "pickDate",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                } else if (value === "1") {
                  this.setState(
                    {
                      timeType: "pickMonth",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                }
              },
              allowClear: false,
              defaultValue: "1",
              labelName: "日期:",
              required: false,
            },
            {
              type: "date",
              dateType: this.state.timeType,
              width: "140px",
              allowClear: false,
              // placeholder: ['请选择',],
              param: {
                name: "time",
                type: "object",
              },
              disabledDate: (current) => {
                let flag = false;
                if (current < moment(new Date("2020-01-01")).endOf("day")) {
                  flag = true;
                }

                if (current && current > moment(new Date()).endOf("day")) {
                  flag = true;
                }
                return flag;
              },
              defaultValue:
                this.state.timeType === "pickMonth"
                  ? moment(new Date()).subtract(0, "m")
                  : moment(new Date()).subtract(0, "d"),
              required: false,
            },
          ],
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询',
              // loading: this.state.loading,
              handler: (e, param) => {
                this.setState(
                  {
                    params: param,
                    chooseDate: param.time,
                    timeType: param.searchType === "1" ? "pickMonth" : "pickDate",
                  },
                  () => {
                    this.initSource();
                    this.top100EquRef.handleGetDataSource();
                    this.top10StationRef.handleGetDataSource();
                    this.top50ChanelRef.handleGetDataSource();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };

    return formConfig;
  }

  initSource = () => {
    this.handleGetMonthData();
    this.handleGetDailyData();
    this.handleGetFirmwareData();
    this.handleGetStopReasonData();
  };

  setLoading = (key, val) => {
    this.setState({
      [`${key}Loading`]: val,
    });
  };

  getFormatter = () => {
    return this.state.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  // 获取月数据
  handleGetMonthData = () => {
    this.setLoading("month", true);
    fetchHandler(getChargeSuccessRateByMon, {
      ...this.state.params,
      time: this.state.params.time.format("YYYYMM"),
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          monthDataList: res.data,
        });
      }
      this.setLoading("month", false);
    });
  };

  // 获取日数据
  handleGetDailyData = () => {
    this.setLoading("day", true);
    fetchHandler(getChargeSuccessRateByDay, {
      ...this.state.params,
      time: this.state.chooseDate.format(this.getFormatter()),
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          dailyDataList: res.data,
        });
      }
      this.setLoading("day", false);
    });
  };

  // 获取固件成功率数据
  handleGetFirmwareData = () => {
    this.setLoading("firmware", true);

    fetchHandler(getChargeSuccessRateByFirmware, {
      ...this.state.params,
      time: this.state.chooseDate.format(this.getFormatter()),
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          firmwareDataList: res.data,
        });
      }
      this.setLoading("firmware", false);
    });
  };

  // 获取停止原因数据源
  handleGetStopReasonData = () => {
    this.setLoading("stopReason", true);

    fetchHandler(getStopReason, {
      ...this.state.params,
      time: this.state.chooseDate.format(this.getFormatter()),
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          stopReasonDataList: res.data,
        });
      }
      this.setLoading("stopReason", false);
    });
  };

  // 点击柱状图选择月份
  mcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      timeType: "pickMonth",
    });
    // 重新加载数据
    this.handleGetDailyData();
    this.handleGetFirmwareData();
    this.handleGetStopReasonData();
    this.top100EquRef.handleGetDataSource();
    this.top10StationRef.handleGetDataSource();
    this.top50ChanelRef.handleGetDataSource();
  };

  // 点击柱状图选择日期
  dcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      timeType: "pickDate",
    });
    this.handleGetFirmwareData();
    this.handleGetStopReasonData();
    this.top100EquRef.handleGetDataSource();
    this.top10StationRef.handleGetDataSource();
    this.top50ChanelRef.handleGetDataSource();
  };

  render() {
    const val = (
      <div
        className='analysis charge-success-rate-container'
        ref='chargSuccsessRate'
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        <Affix target={() => this.refs.chargSuccsessRate}>
          <div className='analysis-title'>
            <FormCore formConfig={this.state.formConfig} />
          </div>
        </Affix>
        <ChargeSuccessMonth
          {...this.props}
          dataSource={this.state.monthDataList}
          setChooseDate={this.mcSetDate}
          chooseDate={this.state.chooseDate}
          loading={this.state.monthLoading}
        />
        <ChargeSuccessDay
          {...this.props}
          dataSource={this.state.dailyDataList}
          setChooseDate={this.dcSetDate}
          chooseDate={this.state.chooseDate}
          loading={this.state.dayLoading}
        />
        <ChargeSuccessFirmware
          {...this.props}
          dataSource={this.state.firmwareDataList}
          loading={this.state.firmwareLoading}
        />

        <StopReason
          {...this.props}
          dataSource={this.state.stopReasonDataList}
          loading={this.state.stopReasonLoading} />

        <Row gutter={24}>
          <Col xl={24} xxl={12}>
            <Top10Station
              {...this.props}
              timeType={this.state.timeType}
              chooseDate={this.state.chooseDate}
              // dataSource={this.state.dailyDataList}
              sortOrderOptions={SORT_ORDER_OPTIONS}
              sortTypeOptions={SORT_TYPE_OPTIONS}
              params={this.state.params}
              ref={(ref) => (this.top10StationRef = ref)}
            />
          </Col>
          <Col xl={24} xxl={12}>
            <Top100Equipment
              {...this.props}
              timeType={this.state.timeType}
              chooseDate={this.state.chooseDate}
              sortOrderOptions={SORT_ORDER_OPTIONS}
              sortTypeOptions={SORT_TYPE_OPTIONS}
              params={this.state.params}
              ref={(ref) => (this.top100EquRef = ref)}
            />
          </Col>
        </Row>

        <Top50Chanel
          {...this.props}
          // timeType={this.state.timeType}
          // chooseDate={this.state.chooseDate}
          // dataSource={this.state.dailyDataList}
          sortOrderOptions={SORT_ORDER_OPTIONS}
          params={this.state.params}
          timeType={this.state.timeType}
          chooseDate={this.state.chooseDate}
          ref={(ref) => (this.top50ChanelRef = ref)}
        />
      </div>
    );
    return val;
  }
}

export default injectIntl(ChargeSuccess);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/chargeSuccess.js